module.exports = __webpack_public_path__ + "static/media/Cakes.fb37720f.jpeg";